//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DropMenus from './DropMenus.vue';
export default {
    components: { DropMenus },
    props: {
        color: {
            type: String,
            default: '#000'
        },
        fontSize: {
            type: String,
            default: '30px'
        }
    },
    data() {
        return {
            menus: [],
            vrData: ''
        };
    },
    computed: {
        active() {
            var name = this.$route.name;
            if (!name) return '';
            const arr = name.split('mini-');
            name = arr.pop();
            return name;
        }
    },
    mounted() {
        this.getMenus();
    },
    methods: {
        getMenus() {
            this.axios({
                url: 'articleCategory/listTree',
                data: {
                    pid: 0
                }
            }).then((res) => {
                if (res) {
                    this.menus = res.data;
                    this.$emit('loaded', this.menus);
                }
            });
        },
        showInfo() {
            this.$router.push({
                name: 'mini-service',
                params: { anchor: 'contact', id: 56 }
            });
        },
        tryTo(location, anchor) {
            this.closeMenu();
            if (location === this.$route.name) {
                return;
            }
            this.$router.push({
                name: 'mini-' + location,
                params: {
                    anchor
                }
            });
        },
        toVrPage() {
            this.$router.push('/mb/vr');
        },
        closeMenu() {
            this.$refs.drop.show = false;
        }
    }
};
